import React from 'react'
import Employe from '../Layout/Employes'

const EmployePage = () => {
  return (
    <Employe />
  )
}

export default EmployePage